var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhoneFilled = function SvgPhoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6611 11.7353C13.4264 12.3094 13.0091 12.8834 12.7483 13.1444C11.2617 14.6318 7.27125 13.3009 3.98504 10.013C0.698825 6.72513 -0.631308 2.75876 0.855312 1.24528C1.11612 0.984334 1.71599 0.566822 2.26369 0.331971C2.68099 0.14931 3.17653 0.279783 3.46342 0.645106L5.10652 2.73267C5.44558 3.15018 5.39341 3.77645 4.97612 4.14177C4.55882 4.50709 4.27193 4.76804 4.19369 4.84632C3.56774 5.47259 4.48058 6.80341 5.86287 8.18642C7.24517 9.56943 8.54922 10.5088 9.20125 9.85647C9.27949 9.77819 9.5403 9.49115 9.90544 9.07363C10.2706 8.65612 10.8704 8.60393 11.3138 8.94316L13.4003 10.5871C13.7394 10.7959 13.8437 11.2917 13.6611 11.7353Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6611 11.7353C13.4264 12.3094 13.0091 12.8834 12.7483 13.1444C11.2617 14.6318 7.27125 13.3009 3.98504 10.013C0.698825 6.72513 -0.631308 2.75876 0.855312 1.24528C1.11612 0.984334 1.71599 0.566822 2.26369 0.331971C2.68099 0.14931 3.17653 0.279783 3.46342 0.645106L5.10652 2.73267C5.44558 3.15018 5.39341 3.77645 4.97612 4.14177C4.55882 4.50709 4.27193 4.76804 4.19369 4.84632C3.56774 5.47259 4.48058 6.80341 5.86287 8.18642C7.24517 9.56943 8.54922 10.5088 9.20125 9.85647C9.27949 9.77819 9.5403 9.49115 9.90544 9.07363C10.2706 8.65612 10.8704 8.60393 11.3138 8.94316L13.4003 10.5871C13.7394 10.7959 13.8437 11.2917 13.6611 11.7353Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7,
    y1: 0.25,
    x2: 7,
    y2: 13.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

export default SvgPhoneFilled;